export function getAvatarUrl(user: any) {
  const foto =
    user?.avatar_url ||
    user?.avatarUrl ||
    user?.profile_photo_url ||
    user?.foto_url ||
    user?.foto ||
    user?.avatar ||
    "";

  if (!foto) return null;
  if (foto.startsWith("http://") || foto.startsWith("https://")) return foto;
  if (foto.startsWith("/storage/")) return foto;

  return `/storage/${foto}`;
}